// extracted by mini-css-extract-plugin
export var attachment = "_p8-a";
export var emailContainer = "_p8-4";
export var emailContentPaddedContainer = "_p8-b";
export var emailHeader = "_p8-6";
export var emailIframe = "_p8-3";
export var emailInfoIcon = "_p8-9";
export var emailShortenedSummary = "_p8-e";
export var infoDropdown = "_p8-0";
export var infoRowBoundedContent = "_p8-d";
export var internal = "_p8-5";
export var merchant = "_p8-8";
export var messageInputContainer = "_p8-h";
export var normal = "_p8-7";
export var replyCard = "_p8-f";
export var subtleButton = "_p8-1";
export var subtleButtonIconContainer = "_p8-2";
export var toggleViewRepliesButton = "_p8-c";
export var wrappingText = "_p8-g";